export const GeoAreaRoute = {
  MyRegion: 'my-region',
  ConvenienceProfile: 'convenience-profile',
  OrganizationProfile: 'organization-profile',
  OrganizationWebview: 'organization-webview'
} as const;

export type GeoAreaRoute = (typeof GeoAreaRoute)[keyof typeof GeoAreaRoute];

export type GeoAreaParam = {
  [GeoAreaRoute.MyRegion]: undefined;
  [GeoAreaRoute.ConvenienceProfile]: { id: string };
  [GeoAreaRoute.OrganizationProfile]: { id: string };
  [GeoAreaRoute.OrganizationWebview]: { id: string };
};
